// extracted by mini-css-extract-plugin
export default {"BurgerMenu":"xY78V","BurgerMenu_opened":"FKmKG","BurgerMenu__btn":"ZHtGg"};